module.exports = __webpack_public_path__ + "static/media/world.b1c5fcdd.png";